<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import VatDeadlineForm from '@/components/vat-deadlines/VatDeadlineForm.vue';
    import { useDateFormat } from '@/composables/useDateFormat';
    import { VatDeadline } from '@/types';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        vatDeadline: VatDeadline;
    }>();

    const { parseDateString } = useDateFormat();

    const parsePeriodStringToIso = (period: string | undefined): { from?: string; to?: string } => {
        if (!period) return {};

        const match = period.match(/(\d{2}[./-]\d{2}[./-]\d{4})\s*-\s*(\d{2}[./-]\d{2}[./-]\d{4})/);
        if (!match) return {};

        const normalize = (s: string) => s.replaceAll('.', '-').replaceAll('/', '-');
        const toIso = (s: string) => parseDateString(normalize(s))?.toString();

        return { from: toIso(match[1]) || undefined, to: toIso(match[2]) || undefined };
    };

    const fallback = parsePeriodStringToIso(props.vatDeadline.settlement_period);

    const form = useForm({
        vat_deadline_id: props.vatDeadline.vat_deadline_id,
        period: props.vatDeadline.period,
        settlement_period_from: props.vatDeadline.settlement_period_from || fallback.from || null,
        settlement_period_to: props.vatDeadline.settlement_period_to || fallback.to || null,
        deadline: props.vatDeadline.deadline,
    });
</script>

<template>
    <DialogForm
        type="update"
        method="patch"
        :form="form"
        :route="route('v2.vat-deadlines.update')"
        :query-key="[QueryKey.VAT_DEADLINES]"
        title="system.edit_vat_deadline"
    >
        <VatDeadlineForm :form="form" />
    </DialogForm>
</template>
